import { graphql } from "gatsby"
import HTMLReactParser from "html-react-parser"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import Slider from "react-slick"
import Media from "../../common/media"
import Title from "../../common/title"
import "./roomFeatured.scss"

const RoomFeatured = ({ description }) => {
  const settings = {
    autoplay: false,
    dots: true,
    infinite: false,
    fade: false,
    speed: 1000,
    autoplaySpeed: 2500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  }

  return (
    <section className="blk-featured blk-spacing">
      <Container>
        <Row className="justify-content-left alignLeft">
          <Col md={8} xs={12}>
            <div className="blk-image-slider animImgTop">
              <Slider {...settings}>
                {description.relationships.block_room_featured_items.map(
                  (media, index) => {
                    return (
                      <div key={index}>
                        <Media
                          media={media.relationships.room_featured_item_media}
                        />
                      </div>
                    )
                  }
                )}
              </Slider>
            </div>
          </Col>
          <Col md={4} xs={12}>
            <div className="blk-description-content pt-100 ml-50">
              <Title text={description.block_room_featured_title} />
              <div className="description animTxt animTxt_3">
                <br />{" "}
                {HTMLReactParser(
                  description.block_room_featured_description.processed
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment getFeaturedRoom on paragraph__block_room_featured {
    block_room_featured_title
    block_room_featured_description {
      processed
    }
    relationships {
      block_room_featured_items {
        relationships {
          room_featured_item_media {
            ...getImageVideo
          }
        }
      }
    }
  }
`

export default RoomFeatured
